import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode } from "vue";
import { ref, watch, onErrorCaptured } from "vue";
import { useRouter, useRoute } from "vue-router";
import { logger } from "@/services/loggerService";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ErrorBoundary',
    setup(__props) {
        const router = useRouter();
        const route = useRoute();
        const hasError = ref(false);
        // The boundary's slot holds the app's ONLY <router-view>. Setting hasError
        // unmounts it, so the post-error push to /error would have no outlet to render
        // into (blank page). Reset on navigation so the destination view mounts.
        watch(() => route.fullPath, () => {
            hasError.value = false;
        });
        onErrorCaptured((err) => {
            hasError.value = true;
            logger.error("Unhandled view error captured by ErrorBoundary", {
                message: err instanceof Error ? err.message : String(err),
            });
            router.push({ name: "Error" });
            // Returning false stops the error from propagating further up.
            return false;
        });
        return (_ctx, _cache) => {
            return (!hasError.value)
                ? _renderSlot(_ctx.$slots, "default", { key: 0 })
                : _createCommentVNode("v-if", true);
        };
    }
});
